import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
	ErrorStatusTypes,
	ErrorsStack,
	parseErrorMessage,
} from "../common/errorsDeclarations";

import * as allegatiApi from "../../api/allegati/allegatiApi";
import { toast } from "react-toastify";
// import { useDispatch } from "react-redux";

export interface TipoDocumento {
	id: number;
	nome: string;
	descrizione?: string;
}
export interface TipiDocumento {
	count: number;
	page: number;
	num_pages: number;
	next?: URL;
	previous?: URL;
	results: TipoDocumento[];
}

export interface Allegato {
	id: number | null;
	tipo_documento: number | null;
	tipo_documento_des?: TipoDocumento;
	descrizione: string;
	ordine?: number | null;
	pagamento?: number | null;

	autore: string;
	file: string;
}

export interface Allegati {
	count: number;
	page: number;
	num_pages: number;
	next?: URL;
	previous?: URL;
	results: Allegato[];
	errorsStack: ErrorsStack;
}

export interface AllegatiState {
	allegato: Allegato;
	errorsStack: ErrorsStack;
}

export interface AllegatiStrutturaState {
	tipiDocumento: TipiDocumento;
	allegati: Allegati;
	allegatoCorrente: AllegatiState;
}

const initialState: AllegatiStrutturaState = {
	tipiDocumento: {
		count: 0,
		page: 0,
		num_pages: 0,
		next: undefined,
		previous: undefined,
		results: [],
	},
	allegati: {
		count: 0,
		page: 0,
		num_pages: 0,
		next: undefined,
		previous: undefined,
		results: [],
		errorsStack: { status: ErrorStatusTypes.OK },
	},
	allegatoCorrente: {
		allegato: {
			id: null,
			tipo_documento: null,
			descrizione: "",
			ordine: null,
			pagamento: null,
			autore: "",
			file: "",
		},
		errorsStack: { status: ErrorStatusTypes.OK },
	},
};

export const fetchTipiDocumento = createAsyncThunk(
	"allegato/fetchTipiDocumento",
	async () => {
		return await allegatiApi.fetchTipiDocumento();
		//   return user;
	}
);
export const fetchAllegati = createAsyncThunk(
	"allegato/fetchAllegati",
	async (parametri: {
		// ordine_id?: number | null;
		// pagamento_id?: number | null;
		tipo_documento_id?: number;
	}) => {
		return await allegatiApi.fetchAllegati(
			// parametri.ordine_id,
			// parametri.pagamento_id,
			parametri.tipo_documento_id
		);
		//   return user;
	}
);

export const uploadAllegato = createAsyncThunk(
	"allegato/uploadAllegato",
	async (
		parametriAllegato: {
			allegato: Allegato;
			file: File;
		},
		thunkApi
	) => {
		return await allegatiApi
			.uploadAllegato(parametriAllegato.allegato, parametriAllegato.file)
			.then((response) => {
				thunkApi.dispatch(
					fetchAllegati({
						// ordine_id: parametriAllegato.allegato.ordine,
						// pagamento_id: parametriAllegato.allegato.pagamento,
					})
				);
				return response;
			});
	}
);

export const mandaDocumentiLotto = createAsyncThunk(
	"allegato/mandaDocumentiLotto",
	async (
		parametriMail: {
			lotto_id: number;
			contatto_id: number;
		},
		thunkApi
	) => {
		return await allegatiApi.mandaDocumentiLotto(
			parametriMail.lotto_id,
			parametriMail.contatto_id
		);
	}
);

export const avvertiUtenteDocumentiLotto = createAsyncThunk(
	"allegato/avvertiUtenteDocumentiLotto",
	async (
		parametriAvvertimento: {
			lotto_id: number;
			utenteEsterno_id: number;
		},
		thunkApi
	) => {
		return await allegatiApi.avvertiUtenteDocumentiLotto(
			parametriAvvertimento.lotto_id,
			parametriAvvertimento.utenteEsterno_id
		);
	}
);

export const deleteAllegato = createAsyncThunk(
	"schedaCarico/deleteAllegato",
	async (allegatoToDelete: Allegato, thunkApi) => {
		const ordine_id = allegatoToDelete.ordine;
		return await allegatiApi
			.deleteAllegato(allegatoToDelete)
			.then((response) => {
				return response;
			});
	}
);

export const allegatiSlice = createSlice({
	name: "allegatiSlice",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		// fetch tipiDocumento
		builder.addCase(fetchTipiDocumento.pending, (state, action) => {
			// state.tipiDocumento.errorsStack = { status: ErrorStatusTypes.PENDING };
		});
		builder.addCase(fetchTipiDocumento.fulfilled, (state, action) => {
			state.tipiDocumento = action.payload;
			// state.tipiDocumento.errorsStack = { status: ErrorStatusTypes.OK };
		});
		builder.addCase(fetchTipiDocumento.rejected, (state, action) => {
			state.allegati.errorsStack = parseErrorMessage(action.error);
		});
		// fetch Allegati
		builder.addCase(fetchAllegati.pending, (state, action) => {
			state.allegati.errorsStack = { status: ErrorStatusTypes.PENDING };
		});
		builder.addCase(fetchAllegati.fulfilled, (state, action) => {
			state.allegati.results = action.payload.results
			// state.allegati.results = [
			// 	...state.allegati.results.filter(
			// 		(allegato) =>
			// 			(!!action.meta.arg.pagamento_id &&
			// 				allegato.pagamento != action.meta.arg.pagamento_id) ||
			// 			(!!action.meta.arg.ordine_id &&
			// 				allegato.ordine != action.meta.arg.ordine_id)
			//
			// 		// (allegato.ordine != action.meta.arg.ordine_id &&
			// 		// 	allegato.pagamento == (undefined || null)) ||
			// 		// allegato.pagamento != action.meta.arg.pagamento_id
			// 	),
			// 	...action.payload.results,
			// ];

			state.allegati.errorsStack = { status: ErrorStatusTypes.OK };
		});
		builder.addCase(fetchAllegati.rejected, (state, action) => {
			state.allegati.errorsStack = parseErrorMessage(action.error);
		});
		// fetch Allegati
		builder.addCase(deleteAllegato.pending, (state, action) => {
			state.allegati.errorsStack = { status: ErrorStatusTypes.PENDING };
		});
		builder.addCase(deleteAllegato.fulfilled, (state, action) => {
			state.allegati.results = state.allegati.results.filter(
				(allegato) => allegato.id != action.meta.arg.id
			);
			toast.success(action.payload.message || "Allegato cancellato.");
			state.allegati.errorsStack = { status: ErrorStatusTypes.OK };
		});
		builder.addCase(deleteAllegato.rejected, (state, action) => {
			state.allegati.errorsStack = parseErrorMessage(action.error);
		});
		// carica Documento
		builder.addCase(uploadAllegato.pending, (state, action) => {
			state.allegatoCorrente.errorsStack = { status: ErrorStatusTypes.PENDING };
		});
		builder.addCase(uploadAllegato.fulfilled, (state, action) => {
			state.allegatoCorrente.errorsStack = { status: ErrorStatusTypes.OK };
			toast.success("Allegato inserito.");
		});
		builder.addCase(uploadAllegato.rejected, (state, action) => {
			state.allegatoCorrente.errorsStack = parseErrorMessage(action.error);
		});
		// invio mail Documenti
		builder.addCase(mandaDocumentiLotto.pending, (state, action) => {
			state.allegatoCorrente.errorsStack = { status: ErrorStatusTypes.PENDING };
		});
		builder.addCase(mandaDocumentiLotto.fulfilled, (state, action) => {
			state.allegatoCorrente.errorsStack = { status: ErrorStatusTypes.OK };
			toast.success("Allegati inviati.");
		});
		builder.addCase(mandaDocumentiLotto.rejected, (state, action) => {
			state.allegatoCorrente.errorsStack = parseErrorMessage(action.error);
		});
		// avverto di Documenti un utente interno
		builder.addCase(avvertiUtenteDocumentiLotto.pending, (state, action) => {
			state.allegatoCorrente.errorsStack = { status: ErrorStatusTypes.PENDING };
		});
		builder.addCase(avvertiUtenteDocumentiLotto.fulfilled, (state, action) => {
			state.allegatoCorrente.errorsStack = { status: ErrorStatusTypes.OK };
			toast.success("Utente avvertito.");
		});
		builder.addCase(avvertiUtenteDocumentiLotto.rejected, (state, action) => {
			state.allegatoCorrente.errorsStack = parseErrorMessage(action.error);
		});
	},
});

// Action creators are generated for each case reducer function
export const {} = allegatiSlice.actions;

export const allegatiSliceReducer = allegatiSlice.reducer;
